(function () {
  if (window._autoScrollCarouselInit) return;
  window._autoScrollCarouselInit = true;

  var SPEED        = 0.833;  // px / frame at 60 fps  (~50 px/s at full speed)
  var SPEED_MOBILE = 0.6;    // px / frame at 60 fps  (~36 px/s on mobile)
  var LERP_BTN     = 0.28;   // snap easing for button clicks  (~180 ms)
  var LERP_SNAP    = 0.2;    // snap easing after touch release (~280 ms, natural)
  var LERP_RESUME  = 0.05;   // ramp-up easing after pause     (~1.5 s to full speed)
  var RESUME_DELAY = 900;    // ms to wait after wheel/button before resuming auto-scroll

  function initCarousel(container) {
    if (container._autoScrollActive) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var grid = container.querySelector('.product-grid');
    if (!grid) return;

    var isMobile       = window.matchMedia('(max-width: 749px)').matches;
    var isTouchPrimary = document.documentElement.classList.contains('touch-tablet');

    // +1 = RTL (products drift left), -1 = LTR (products drift right)
    var dir   = (container.dataset.scrollDir === 'ltr') ? -1 : 1;
    var speed = isMobile ? SPEED_MOBILE : SPEED;
    container._autoScrollActive = true;

    var currentSpeed   = 0;
    var hovered        = false;
    var desktopPaused  = false;
    var touchLocked    = false;
    var snapTarget     = null;
    var resumeTimer    = null;
    var rafId          = null;
    var lastTime       = null;
    var originalWidth  = 0;
    var prependWidth   = 0;
    var scrollPos      = null; // float accumulator for sub-pixel smooth scrolling
    var mobileCentered = null; // currently active item on mobile
    var mobileItems    = null; // originals array cached after buildLoop
    var pinchActive           = false;
    var momentumScrollLeft    = null; // tablet momentum tracking
    var momentumScrollTime    = null;
    var cancelSnapTimer       = null; // mobile: deferred snap from touchcancel
    var resizeDebounce        = null;
    var touchStartScrollLeft  = 0;    // scrollLeft when finger first touches
    var touchStartCenterItem  = null; // item centred at touchstart
    var touchSnapLerp         = false; // use slower LERP after touch release
    var touchMoveHistory      = [];   // [{x, t}] last few touchmove clientX + timestamp
    var touchStartClientX     = 0;
    var touchStartClientY     = 0;
    var touchIsHorizontal     = null; // null=undecided, true=horiz, false=vert
    var touchOnButton         = false; // true when tap started on a button (cart/wishlist)
    var touchLockedSince      = 0;    // timestamp when touchLocked was last set to true

    // ── Helpers ───────────────────────────────────────────────────────────

    function cloneItem(item) {
      var c = item.cloneNode(true);
      c.classList.add('carousel-clone');
      c.setAttribute('aria-hidden', 'true');
      c.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--cancel');
      c.querySelectorAll('.scroll-trigger--offscreen, .scroll-trigger--cancel').forEach(function (el) {
        el.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--cancel');
      });
      // Clones share the same image URLs as the originals so they load from cache.
      // Without eager loading, lazy clone images show blank when the loop wraps
      // and PrepClones briefly appear during momentum scroll.
      c.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.setAttribute('loading', 'eager');
      });
      return c;
    }

    // Return the normalised scroll offset within [0, originalWidth) so the
    // centred-item calculation is correct both before and after a teleport.
    function normalisedCenter() {
      if (!originalWidth) return 0;
      var sl = ((grid.scrollLeft - prependWidth) % originalWidth + originalWidth) % originalWidth;
      var c  = sl + grid.clientWidth / 2;
      // If the centre straddles the wrap boundary, keep it in [0, originalWidth)
      return c % originalWidth;
    }

    // Mobile: show secondary image on the item whose centre is visually closest
    // to the carousel centre. Uses wrap-aware distance so teleports never cause
    // the wrong item to be selected. instant=true skips the CSS fade (initial set).
    function updateCenteredCard(instant) {
      if (!mobileItems || !originalWidth || pinchActive) return;
      var center = normalisedCenter();
      var best = null, bestDist = Infinity;
      mobileItems.forEach(function (item) {
        // Normalise item centre to [0, originalWidth)
        var ic = ((item.offsetLeft - prependWidth) + item.offsetWidth / 2 + originalWidth) % originalWidth;
        // Wrap-aware distance (take the shorter arc)
        var d  = Math.abs(ic - center);
        if (d > originalWidth / 2) d = originalWidth - d;
        if (d < bestDist) { bestDist = d; best = item; }
      });
      if (best === mobileCentered) return;
      // Deactivate previous
      if (mobileCentered) {
        var oldCw = mobileCentered.querySelector('.card-wrapper');
        if (oldCw) oldCw.classList.remove('carousel-centered');
      }
      mobileCentered = best;
      // Activate new
      if (best) {
        var cw = best.querySelector('.card-wrapper');
        if (cw) {
          if (instant) {
            // Bypass CSS transition so second image is already visible on first paint.
            best.querySelectorAll('.media.media--hover-effect img').forEach(function (img) {
              img.style.transitionDuration = '0s';
            });
            cw.classList.add('carousel-centered');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                best.querySelectorAll('.media.media--hover-effect img').forEach(function (img) {
                  img.style.transitionDuration = '';
                });
              });
            });
          } else {
            cw.classList.add('carousel-centered');
          }
        }
      }
    }


    // Build triple-band layout: [PrepClones | Originals | AppClones]
    function buildLoop() {
      var originals = Array.from(grid.querySelectorAll('.grid__item:not(.carousel-clone)'));
      if (!originals.length) return;

      var rawWidth = grid.scrollWidth;
      if (rawWidth <= grid.clientWidth) return;
      originalWidth = rawWidth;

      originals.forEach(function (item) {
        item.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--cancel');
        item.querySelectorAll('.scroll-trigger--offscreen, .scroll-trigger--cancel').forEach(function (el) {
          el.classList.remove('scroll-trigger--offscreen', 'scroll-trigger--cancel');
        });
      });

      var cloneCount = Math.min(originals.length, 8);
      var itemWidth  = rawWidth / originals.length;
      prependWidth   = Math.round(cloneCount * itemWidth);

      // PrepClones copy the LAST cloneCount originals. Those items are often far
      // off-screen and still lazy/unloaded. Changing loading="eager" on an already-
      // inserted img doesn't retroactively fetch in all browsers, so also fire a
      // side-channel Image() preload to guarantee they're in cache before the user
      // can fast-swipe into the PrepClone zone.
      for (var k = originals.length - cloneCount; k < originals.length; k++) {
        originals[k].querySelectorAll('img').forEach(function (img) {
          img.setAttribute('loading', 'eager');
          if (!img.complete) {
            var pre = new Image();
            if (img.srcset) pre.srcset = img.srcset;
            pre.src = img.src;
          }
        });
      }

      // AppClones copy the FIRST cloneCount originals. Preload their source images the same
      // way as PrepClone sources — fast forward-swipe into the AppClone zone (first products)
      // can otherwise stall on iPad while Safari re-fetches evicted images.
      for (var a = 0; a < cloneCount; a++) {
        originals[a].querySelectorAll('img').forEach(function (img) {
          img.setAttribute('loading', 'eager');
          if (!img.complete) {
            var pre = new Image();
            if (img.srcset) pre.srcset = img.srcset;
            pre.src = img.src;
          }
        });
      }

      for (var i = 0; i < cloneCount; i++) {
        grid.appendChild(cloneItem(originals[i]));
      }
      var frag = document.createDocumentFragment();
      for (var j = originals.length - cloneCount; j < originals.length; j++) {
        frag.appendChild(cloneItem(originals[j]));
      }
      grid.insertBefore(frag, grid.firstChild);

      var prevScroll = grid.scrollLeft;
      grid.scrollLeft = prependWidth + prevScroll;
      scrollPos = grid.scrollLeft;

      if (isMobile) {
        mobileItems = Array.from(grid.querySelectorAll('.grid__item:not(.carousel-clone)'));
        updateCenteredCard(true);
      }
    }

    // Teleport scrollLeft back into the Originals band [prependWidth, prependWidth+OW).
    function correctLoop() {
      if (!originalWidth) return;
      var sl = grid.scrollLeft;
      if (sl >= prependWidth + originalWidth) {
        grid.scrollLeft = sl - originalWidth;
        if (scrollPos  !== null) scrollPos  -= originalWidth;
        if (touchLocked)         touchStartScrollLeft -= originalWidth;
        if (snapTarget  !== null) snapTarget -= originalWidth;
      } else if (sl < prependWidth) {
        grid.scrollLeft = sl + originalWidth;
        if (scrollPos  !== null) scrollPos  += originalWidth;
        if (touchLocked)         touchStartScrollLeft += originalWidth;
        if (snapTarget  !== null) snapTarget += originalWidth;
      }
    }

    // ── Setup ─────────────────────────────────────────────────────────────

    grid.style.scrollBehavior = 'auto';
    grid.style.scrollSnapType = 'none';
    grid.style.overflowAnchor  = 'none';
    // On mobile: skip will-change:scroll-position (prevents iOS from creating a
    // large composite layer across the full scroll width, which gets rasterized
    // at full res during pinch-to-zoom and can OOM). Also:
    // touch-action:pan-x removes the grid from the browser's pinch-to-zoom
    // rasterisation path; overscroll-behavior-x:none kills rubber-band bounce
    // at the boundaries that would expose blank space between teleport corrections.
    if (isMobile) {
      grid.style.willChange           = 'auto';
      // pan-y: browser handles vertical page-scroll natively; horizontal is driven by
      // our touchmove handler (1:1 finger tracking, no momentum). Excludes pinch-zoom
      // from the carousel's rasterisation path — same crash protection as pan-x pan-y.
      grid.style.touchAction          = 'pan-y';
      grid.style.overscrollBehaviorX  = 'none';
      // overflow-x:hidden removes iOS's native horizontal scroll container.
      // Without this, iOS Safari runs its own scroll compositor for the element alongside
      // our JS scrollLeft updates, and iOS wins visually — the carousel only "jumps" at
      // touchend instead of tracking the finger. Hidden overflow means our JS is the sole
      // driver of horizontal position, giving 1:1 finger tracking on iPhone.
      grid.style.overflowX            = 'hidden';
    } else {
      grid.style.willChange          = 'scroll-position';
      grid.style.overscrollBehaviorX = 'none';
    }

    var sliderComponent = grid.parentElement;

    if (sliderComponent) {
      sliderComponent.querySelectorAll('.slider-button').forEach(function (btn) {
        btn.removeAttribute('disabled');
        Object.defineProperty(btn, 'disabled', { get: function () { return false; }, set: function () {}, configurable: true });
        var _sa = btn.setAttribute.bind(btn);
        btn.setAttribute = function (name, val) { if (name === 'disabled') return; _sa(name, val); };
        var _ta = btn.toggleAttribute.bind(btn);
        btn.toggleAttribute = function (name, force) { if (name === 'disabled') return false; return _ta(name, force); };
      });

      if ('slider' in sliderComponent) {
        sliderComponent._savedSlider = sliderComponent.slider;
        sliderComponent.slider = null;
      }
      if (typeof sliderComponent.initPages === 'function') {
        sliderComponent._savedInitPages = sliderComponent.initPages;
        sliderComponent.initPages = function () {};
      }
    }

    // ── Animation tick ────────────────────────────────────────────────────

    function tick(now) {
      if (lastTime === null) lastTime = now;
      var dt     = now - lastTime;
      if (dt > 50) dt = 1000 / 60;
      lastTime   = now;
      var frames = dt / (1000 / 60);

      if (snapTarget !== null) {
        var diff = snapTarget - grid.scrollLeft;
        if (Math.abs(diff) < 1) {
          grid.scrollLeft = Math.round(snapTarget);
          snapTarget = null;
          touchSnapLerp = false;
          correctLoop();
          updateCenteredCard(); // update once snap has settled to avoid mid-animation flicker
        } else {
          var lerpRate = touchSnapLerp ? LERP_SNAP : LERP_BTN;
          var delta = diff * lerpRate * frames;
          if (Math.abs(delta) < 1) delta = diff > 0 ? 1 : -1;
          grid.scrollLeft += delta;
        }
        currentSpeed = 0;

      } else if (hovered || desktopPaused || touchLocked) {
        currentSpeed = 0;
        correctLoop();

      } else {
        currentSpeed += (1 - currentSpeed) * LERP_RESUME * frames;
        if (currentSpeed > 0.001 && originalWidth > 0) {
          if (scrollPos === null || Math.abs(scrollPos - grid.scrollLeft) > 1) scrollPos = grid.scrollLeft;
          scrollPos += dir * speed * currentSpeed * frames;
          if      (scrollPos >= prependWidth + originalWidth) scrollPos -= originalWidth;
          else if (scrollPos <  prependWidth)                 scrollPos += originalWidth;
          grid.scrollLeft = scrollPos;
        }
      }

      rafId = requestAnimationFrame(tick);
    }

    // ── Event handlers ────────────────────────────────────────────────────

    function onMouseEnter() {
      if (touchLocked) return;
      hovered = true;
      currentSpeed = 0;
      correctLoop();
    }

    function onMouseLeave() {
      hovered    = false;
      snapTarget = null;
    }

    function onWheel() {
      currentSpeed  = 0;
      desktopPaused = true;
      snapTarget    = null;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { desktopPaused = false; }, RESUME_DELAY);
    }

    function onTouchStart(e) {
      if (e.touches && e.touches.length >= 2) {
        pinchActive = true;
        if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      }
      // Button taps (cart, wishlist, quick-add) must not affect carousel state.
      // Broadened selector: catches <button>, [data-wishlist-toggle], and <a class="card__mobile-atc">
      // (the multi-variant "choose options" link that is an <a>, not a <button>).
      touchOnButton = isMobile && !!(e.target && typeof e.target.closest === 'function' &&
        e.target.closest('button, [data-wishlist-toggle], .card__mobile-atc'));
      if (touchOnButton) {
        // Immediately unlock — don't touch resumeTimer so any post-swipe timer stays intact.
        touchLocked = false;
        if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        return;
      }
      // If a deferred touchcancel snap is pending (iOS mid-swipe callout pattern),
      // cancel it — the finger is back on screen and starting a new gesture.
      if (cancelSnapTimer !== null) { clearTimeout(cancelSnapTimer); cancelSnapTimer = null; }
      snapTarget = null;
      if (!isMobile) {
        // Tablet: stop auto-scroll immediately on any touch.
        touchLocked  = true;
        currentSpeed = 0;
        clearTimeout(resumeTimer);
        if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      } else {
        // Mobile: direction is unknown — don't stop auto-scroll yet.
        // onTouchMove sets touchLocked=true only once a horizontal swipe is confirmed.
        // Vertical page-scrolls must never pause the carousel.
        // Release any lingering lock from the previous swipe so a vertical scroll
        // during the 2-second resume window doesn't keep the carousel frozen.
        if (touchLocked) { clearTimeout(resumeTimer); touchLocked = false; }
      }
      touchMoveHistory  = [];
      touchIsHorizontal = null;
      if (isMobile && e.touches && e.touches.length === 1) {
        touchStartClientX = e.touches[0].clientX;
        touchStartClientY = e.touches[0].clientY;
      }
      if (isMobile) {
        touchStartScrollLeft = grid.scrollLeft;
        var items = Array.from(grid.querySelectorAll('.grid__item'));
        var best = null, bestDist = Infinity;
        items.forEach(function (item) {
          var d = Math.abs(item.offsetLeft - grid.scrollLeft);
          if (d < bestDist) { bestDist = d; best = item; }
        });
        touchStartCenterItem = best;
      }
    }

    function onTouchMove(e) {
      var touch = e.touches && e.touches[0];
      if (!isMobile || touchOnButton || pinchActive || (e.touches && e.touches.length > 1)) return;
      if (!touch) return;

      // Record finger position for velocity calculation in snapAfterTouch
      touchMoveHistory.push({ x: touch.clientX, t: Date.now() });
      if (touchMoveHistory.length > 8) touchMoveHistory.shift();

      // Establish direction lock on the first significant movement
      if (touchIsHorizontal === null) {
        var dx = Math.abs(touch.clientX - touchStartClientX);
        var dy = Math.abs(touch.clientY - touchStartClientY);
        if (dx > 5 || dy > 5) {
          touchIsHorizontal = dx >= dy;
          if (touchIsHorizontal) {
            // Horizontal swipe confirmed — stop auto-scroll and re-anchor reference points.
            // Auto-scroll may have moved the grid since touchstart, so capture the current
            // scroll position and finger position as the new zero-delta reference pair.
            touchLocked          = true;
            touchLockedSince     = Date.now();
            currentSpeed         = 0;
            clearTimeout(resumeTimer);
            touchStartScrollLeft = grid.scrollLeft;
            touchStartClientX    = touch.clientX;
            // Re-capture the nearest item at the current scroll position (stale if auto-scroll ran).
            var lockItems = Array.from(grid.querySelectorAll('.grid__item'));
            var lockBest = null, lockBestDist = Infinity;
            lockItems.forEach(function (item) {
              var d = Math.abs(item.offsetLeft - grid.scrollLeft);
              if (d < lockBestDist) { lockBestDist = d; lockBest = item; }
            });
            touchStartCenterItem = lockBest;
          }
        }
      }

      if (touchIsHorizontal) {
        grid.scrollLeft = touchStartScrollLeft + (touchStartClientX - touch.clientX);
      }
    }

    // Shared snap logic called by both touchend and touchcancel.
    // Direction is determined from finger VELOCITY (touchmove clientX history), not from
    // grid.scrollLeft delta — momentum has often already moved the scroll far from the
    // finger by the time touchend/touchcancel fires, especially on Android.
    // Then takes the SHORT circular path so the LERP never travels more than one item width.
    function snapAfterTouch() {
      if (!isMobile || !originalWidth || !touchStartCenterItem) return;

      // Velocity in px/ms: positive = finger moved left = scroll forward
      var velocity = 0;
      if (touchMoveHistory.length >= 2) {
        var newest = touchMoveHistory[touchMoveHistory.length - 1];
        var oldest = touchMoveHistory[0];
        var dt = newest.t - oldest.t;
        if (dt > 0 && dt < 250) velocity = (oldest.x - newest.x) / dt;
      }
      var VELOCITY_THRESHOLD = 0.2; // px/ms (~200 px/s) — deliberate swipe

      var items = Array.from(grid.querySelectorAll('.grid__item'));
      var idx = items.indexOf(touchStartCenterItem);
      var targetItem = touchStartCenterItem;
      if (velocity >  VELOCITY_THRESHOLD && idx < items.length - 1) targetItem = items[idx + 1];
      if (velocity < -VELOCITY_THRESHOLD && idx > 0)                targetItem = items[idx - 1];
      var raw = Math.round(targetItem.offsetLeft);
      if (raw < prependWidth)                      raw += originalWidth;
      else if (raw >= prependWidth + originalWidth) raw -= originalWidth;

      // Short circular path: if the direct distance is more than half the carousel,
      // route via the clone band so the LERP only travels one item width.
      var dist = raw - grid.scrollLeft;
      if (dist < -(originalWidth / 2)) raw += originalWidth;
      else if (dist >  (originalWidth / 2)) raw -= originalWidth;

      touchSnapLerp = true;
      snapTarget = raw;
    }

    function onTouchEnd(e) {
      if (e.touches && e.touches.length < 2) {
        pinchActive = false;
        // Restart RAF if a pinch stopped it and fingers are now lifting (Android has no gestureend)
        if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
      }
      if (touchOnButton) {
        touchOnButton = false;
        touchLocked = false;
        if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        return;
      }
      if (isMobile) {
        clearTimeout(resumeTimer);
        if (touchIsHorizontal === true) {
          // Horizontal swipe ended — snap to nearest/next item, then resume auto-scroll.
          snapAfterTouch();
        }
        // Always schedule the resume — guarantees touchLocked is released after any mobile
        // touch (swipe, tap, or button press) using the same 2-second delay as a swipe.
        resumeTimer = setTimeout(function () {
          touchLocked = false;
          if (!pinchActive && buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        }, 2000);
      } else {
        clearTimeout(resumeTimer);
        // Tablet: restart auto-scroll immediately if no momentum, or once momentum decays
        momentumScrollLeft = null;
        momentumScrollTime = null;
        resumeTimer = setTimeout(function () {
          touchLocked = false;
          momentumScrollLeft = null;
          if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        }, 120);
      }
    }

    function onTouchCancel() {
      if (touchOnButton) {
        touchOnButton = false;
        pinchActive = false;
        touchLocked = false;
        if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        return;
      }
      clearTimeout(resumeTimer);
      pinchActive = false;
      if (isMobile) {
        if (touchIsHorizontal === true) {
          // Horizontal swipe was interrupted (iOS callout, edge gesture).
          // Defer snap: if finger is still on screen iOS fires a new touchstart soon —
          // onTouchStart cancels this timer. Otherwise snap fires after 100 ms.
          cancelSnapTimer = setTimeout(function () {
            cancelSnapTimer = null;
            snapAfterTouch();
            resumeTimer = setTimeout(function () {
              touchLocked = false;
              if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
            }, 2000);
          }, 100);
        } else {
          // Non-swipe touch cancelled (button tap, DOM change from cart/wishlist action) —
          // guarantee touchLocked is always released after the same delay as a swipe.
          resumeTimer = setTimeout(function () {
            touchLocked = false;
            if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
          }, 2000);
        }
      } else {
        momentumScrollLeft = null;
        momentumScrollTime = null;
        // Use a long delay: on iPad, touchcancel fires for long-press/system gestures while
        // the finger is still physically on screen. A short timer would restart auto-scroll
        // before the user lifts. onTouchStart will cancel this if a new touch begins.
        resumeTimer = setTimeout(function () {
          touchLocked = false;
          momentumScrollLeft = null;
          if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        }, 2000);
      }
    }

    function onButtonClick(e) {
      var btn = e.target.closest('.slider-button--prev, .slider-button--next');
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      if (!originalWidth) return;

      var scrollDir = btn.classList.contains('slider-button--next') ? 1 : -1;
      currentSpeed  = 0;
      snapTarget    = null;
      desktopPaused = true;
      clearTimeout(resumeTimer);

      var origItems = Array.from(grid.querySelectorAll('.grid__item:not(.carousel-clone)'));
      if (origItems.length) {
        var gridRect = grid.getBoundingClientRect();
        var stride   = origItems.length > 1
          ? Math.abs(origItems[1].getBoundingClientRect().left - origItems[0].getBoundingClientRect().left)
          : origItems[0].getBoundingClientRect().width;
        var nearest  = origItems.reduce(function (best, item) {
          return Math.abs(item.getBoundingClientRect().left - gridRect.left) <
                 Math.abs(best.getBoundingClientRect().left - gridRect.left) ? item : best;
        });
        snapTarget = Math.round(grid.scrollLeft + (nearest.getBoundingClientRect().left - gridRect.left) + scrollDir * stride);
      }
      resumeTimer = setTimeout(function () { desktopPaused = false; }, RESUME_DELAY);
    }

    // Pause/resume RAF based on page-viewport visibility.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          if (touchLocked) touchLocked = false;
          if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
        } else if (buildDone && rafId === null) {
          lastTime = null;
          rafId = requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0, rootMargin: '300px 0px' });
    observer.observe(container);

    // ── Wire up ───────────────────────────────────────────────────────────

    // Scroll handler: run correctLoop FIRST — if a teleport is needed it fires
    // another scroll event so updateCenteredCard always sees post-teleport position.
    function onScrollCorrect() {
      if (pinchActive) return;
      if (!originalWidth) { updateCenteredCard(); return; }
      // Suppress card updates while a snap is animating — tick() calls updateCenteredCard
      // once the snap settles, preventing mid-animation flicker on backward wrap.
      if (snapTarget !== null) return;
      var sl = grid.scrollLeft;
      if (sl >= prependWidth + originalWidth || sl < prependWidth) {
        correctLoop(); // teleport fires a second scroll event → updateCenteredCard runs there
        return;
      }
      // Tablet: measure native momentum velocity; restart RAF once it decays to auto-scroll speed.
      // Each scroll event resets a 200ms debounce so we also restart cleanly when momentum stops.
      if (touchLocked && !isMobile && buildDone) {
        var now = performance.now();
        if (momentumScrollLeft !== null) {
          var dt = now - momentumScrollTime;
          if (dt >= 16) {
            var vel = Math.abs(sl - momentumScrollLeft) / dt; // px/ms
            if (vel <= (speed / (1000 / 60)) * 2) { // within 2× auto-scroll speed → hand back
              clearTimeout(resumeTimer);
              touchLocked = false;
              momentumScrollLeft = null;
              if (rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
              return;
            }
          }
        }
        if (touchLocked) {
          momentumScrollLeft = sl;
          momentumScrollTime = now;
          clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () { // fires when scroll stops entirely
            touchLocked = false;
            momentumScrollLeft = null;
            if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
          }, 200);
        }
        return;
      }
      // Skip during active horizontal drag — rapid class toggling triggers the 0.8 s
      // CSS fade on every scroll event; tick() calls updateCenteredCard once snap settles.
      if (!touchIsHorizontal) updateCenteredCard();
    }

    var hoverZone = sliderComponent || grid;
    hoverZone.addEventListener('mouseenter', onMouseEnter);
    hoverZone.addEventListener('mouseleave', onMouseLeave);
    grid.addEventListener('scroll',      onScrollCorrect, { passive: true });
    grid.addEventListener('wheel',       onWheel,         { passive: true });
    grid.addEventListener('touchstart',  onTouchStart,    { passive: true });
    grid.addEventListener('touchmove',   onTouchMove,     { passive: true });
    grid.addEventListener('touchend',    onTouchEnd,      { passive: true });
    grid.addEventListener('touchcancel', onTouchCancel,   { passive: true });
    if (sliderComponent) sliderComponent.addEventListener('click', onButtonClick, true);

    // Pause during pinch-to-zoom via all three available signals.
    function onGestureStart() { pinchActive = true; if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; } }
    function onGestureEnd()   { pinchActive = false; if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); } }
    window.addEventListener('gesturestart', onGestureStart, { passive: true });
    window.addEventListener('gestureend',   onGestureEnd,   { passive: true });

    // window resize fires on every zoom step — cancel RAF immediately, restart 250ms after zoom ends.
    function onWindowResize() {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function () {
        if (buildDone && rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
      }, 250);
    }
    window.addEventListener('resize', onWindowResize, { passive: true });

    // Watchdog: on mobile, if touchLocked gets stuck (browser swallows touchend/touchcancel
    // after a button tap, or onInteractionResume was clearing the resume timer), force-clear
    // it after 2.5 s — safely past the intentional 2 s post-swipe pause so normal swipes
    // are unaffected. Also restarts RAF if it stopped unexpectedly.
    var watchdogInterval = null;
    if (isMobile) {
      watchdogInterval = setInterval(function () {
        if (!buildDone || pinchActive || hovered || desktopPaused || snapTarget !== null) return;
        if (touchLocked && Date.now() - touchLockedSince > 2100) { touchLocked = false; }
        if (rafId === null && !touchLocked) { lastTime = null; rafId = requestAnimationFrame(tick); }
      }, 200);
    }

    // Defer buildLoop + RAF until carousel is near viewport.
    var buildDone = false;
    var buildObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || buildDone) return;
        buildDone = true;
        buildObserver.disconnect();
        setTimeout(function () {
          buildLoop();
          if (rafId === null) { lastTime = null; rafId = requestAnimationFrame(tick); }
        }, 150);
      });
    }, { threshold: 0, rootMargin: '0px 0px 600px 0px' });
    buildObserver.observe(container);

    // ── Desktop image cycling ─────────────────────────────────────────────

    var cycleActive    = null;
    var cycleLast      = null;
    var cyclePaused    = false;
    var cycleTimer     = null;
    var onCycleEnter   = null;
    var onCycleLeave   = null;
    var setCycleActive = null; // assigned below; shared with tablet touch handlers
    var resumeCycling  = null; // assigned below; shared with tablet touch handlers

    if (!isMobile) {
      var CYCLE_DURATION = 5000;

      function getVisibleItems() {
        var cr = grid.getBoundingClientRect();
        return Array.from(grid.querySelectorAll('.grid__item:not(.carousel-clone)')).filter(function (item) {
          var r = item.getBoundingClientRect();
          return r.left >= cr.left && r.right <= cr.right;
        });
      }

      function pickCycleNext() {
        var vis  = getVisibleItems();
        var pool = vis.filter(function (item) { return item !== cycleActive && item !== cycleLast; });
        if (!pool.length) pool = vis.filter(function (item) { return item !== cycleActive; });
        if (!pool.length) pool = vis;
        return pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
      }

      setCycleActive = function (item) {
        if (cycleActive) {
          var w = cycleActive.querySelector('.card-wrapper');
          if (w) w.classList.remove('card-wrapper--active');
          cycleLast = cycleActive;
        }
        cycleActive = item;
        if (item) {
          var cw = item.querySelector('.card-wrapper');
          if (cw) cw.classList.add('card-wrapper--active');
        } else {
          // Defensive sweep: clear any element that got the class but isn't tracked in cycleActive
          grid.querySelectorAll('.card-wrapper--active').forEach(function (el) {
            el.classList.remove('card-wrapper--active');
          });
          cycleLast = null;
        }
      };

      function scheduleCycle() {
        clearTimeout(cycleTimer);
        cycleTimer = setTimeout(function () {
          if (!cyclePaused) setCycleActive(pickCycleNext());
          scheduleCycle();
        }, CYCLE_DURATION);
      }

      // On touch tablets: keep the last touched item active until cycling naturally picks the next
      resumeCycling = function () {
        setCycleActive(null); // immediately revert to first image on finger lift
        cyclePaused = false;
        clearTimeout(cycleTimer);
        cycleTimer = setTimeout(function () {
          if (!cyclePaused) { setCycleActive(pickCycleNext()); scheduleCycle(); }
        }, 2000);
      };

      if (!isTouchPrimary) {
        // Desktop only: pause cycling on mouse hover, resume on leave
        onCycleEnter = function () { cyclePaused = true; setCycleActive(null); };
        onCycleLeave = function () { cyclePaused = false; scheduleCycle(); };
        hoverZone.addEventListener('mouseenter', onCycleEnter);
        hoverZone.addEventListener('mouseleave', onCycleLeave);
      }

      cycleTimer = setTimeout(function () { setCycleActive(pickCycleNext()); scheduleCycle(); }, 2500);
    }

    // ── Cleanup ───────────────────────────────────────────────────────────

    container._autoScrollDestroy = function () {
      cancelAnimationFrame(rafId);
      clearTimeout(resumeTimer);
      clearTimeout(cycleTimer);
      clearTimeout(resizeDebounce);
      clearTimeout(cancelSnapTimer);
      observer.disconnect();
      buildObserver.disconnect();
      if (cycleActive) {
        var cw = cycleActive.querySelector('.card-wrapper');
        if (cw) cw.classList.remove('card-wrapper--active');
        cycleActive = null;
      }
      if (mobileCentered) {
        var cw = mobileCentered.querySelector('.card-wrapper');
        if (cw) cw.classList.remove('carousel-centered');
        mobileCentered = null;
      }
      if (onCycleEnter) {
        hoverZone.removeEventListener('mouseenter', onCycleEnter);
        hoverZone.removeEventListener('mouseleave', onCycleLeave);
      }
      grid.style.scrollBehavior      = '';
      grid.style.scrollSnapType      = '';
      grid.style.overflowAnchor      = '';
      grid.style.willChange          = '';
      grid.style.touchAction         = '';
      grid.style.overscrollBehaviorX = '';
      grid.style.overflowX           = '';
      if (sliderComponent) {
        if (sliderComponent._savedSlider !== undefined) { sliderComponent.slider = sliderComponent._savedSlider; delete sliderComponent._savedSlider; }
        if (sliderComponent._savedInitPages) { sliderComponent.initPages = sliderComponent._savedInitPages; delete sliderComponent._savedInitPages; }
        sliderComponent.querySelectorAll('.slider-button').forEach(function (btn) { delete btn.disabled; });
        sliderComponent.removeEventListener('click', onButtonClick, true);
      }
      hoverZone.removeEventListener('mouseenter', onMouseEnter);
      hoverZone.removeEventListener('mouseleave', onMouseLeave);
      grid.removeEventListener('scroll',      onScrollCorrect);
      grid.removeEventListener('wheel',       onWheel);
      grid.removeEventListener('touchstart',  onTouchStart);
      grid.removeEventListener('touchmove',   onTouchMove);
      grid.removeEventListener('touchend',    onTouchEnd);
      grid.removeEventListener('touchcancel', onTouchCancel);
      window.removeEventListener('gesturestart', onGestureStart);
      window.removeEventListener('gestureend',   onGestureEnd);
      window.removeEventListener('resize',       onWindowResize);
      if (watchdogInterval) clearInterval(watchdogInterval);
      grid.querySelectorAll('.carousel-clone').forEach(function (c) { c.remove(); });
      delete container._autoScrollActive;
      delete container._autoScrollDestroy;
    };
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────

  function initAll() {
    document.querySelectorAll('[data-auto-scroll-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-auto-scroll-carousel]').forEach(initCarousel);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-auto-scroll-carousel]').forEach(function (c) {
      if (c._autoScrollDestroy) c._autoScrollDestroy();
    });
  });

  (function () {
    function prefetchCart() {
      var link = document.createElement('link');
      link.rel  = 'prefetch';
      link.href = '/cart?sections=cart-drawer';
      document.head.appendChild(link);
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchCart, { timeout: 3000 });
    } else {
      setTimeout(prefetchCart, 1500);
    }
  }());
})();
